module.exports = lib_lib;


/*****************
 ** WEBPACK FOOTER
 ** external "lib_lib"
 ** module id = 2
 ** module chunks = 0
 **/